import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgIdleModule } from "@ng-idle/core";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlyModule } from "@ngx-formly/core";
import { ColorPickerModule } from "ngx-color-picker";
import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CalendarModule } from "primeng/calendar";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ChipsModule } from "primeng/chips";
import { ColorPickerModule as PrimeNgColorPickerModule } from "primeng/colorpicker";
import { ContextMenuModule } from "primeng/contextmenu";
import { DragDropModule } from "primeng/dragdrop";
import { DropdownModule } from "primeng/dropdown";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextareaModule } from "primeng/inputtextarea";
import { MenuModule } from "primeng/menu";
import { MultiSelectModule } from "primeng/multiselect";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { PanelModule } from 'primeng/panel';
import { ChipModule } from 'primeng/chip';
import { AppContextMenuComponent } from "../../components/app-context-menu/app-context-menu.component";
import { AsyncModalComponent } from "../../components/async-modal/async-modal.component";
import { AttachmentMenu } from "../../components/attachment-menu/attachment-menu.component";
import { BreadcrumbComponent } from "../../components/breadcrumbs/component";
import { ClientSwitcherComponent } from "../../components/client-switcher/client-switcher.component";
import { CustomMenu } from "../../components/custom-menu/custom-menu.component";
import { DataList } from "../../components/datalist/datalist.component";
import { DataListItem } from "../../components/datalist/datalistitem/datalistitem.component";
import { DataTable } from "../../components/datatable/datatable.component";
import { DataTableColumn } from "../../components/datatable/datatablecolumn/datatablecolumn.component";
import { DocumentManagementSystem } from "../../components/dms/dms.component";
import { DropDown } from "../../components/dropdown/dropdown.component";
import { DropDownData } from "../../components/dropdown/dropdowndata/dropdowndata.component";
import { FooterBar } from "../../components/footer/footer.component";
import { AccordionComponent } from "../../components/formlyTypes/accordion/accordion.component";
import { FormlyColourPicker } from "../../components/formlyTypes/colour-picker/colour-picker.component";
import { FormlyDmsButtons } from "../../components/formlyTypes/dms-buttons/dms-buttons.component";
import { FormlyFileUploader } from "../../components/formlyTypes/file-uploader/file-uploader.component";
import { FormlyHorizontalCheckbox } from "../../components/formlyTypes/horizontalCheckbox/horizontalCheckbox.component";
import { FormlyHorizontalDateInput } from "../../components/formlyTypes/horizontalDateInput/horizontalDateInput.component";
import { FormlyHorizontalInput } from "../../components/formlyTypes/horizontalInput/horizontalInput.component";
import { FormlyHorizontalMultiSelect } from "../../components/formlyTypes/horizontalMultiSelect/horizontalMultiSelect.component";
import { FormlyHorizontalSelect } from "../../components/formlyTypes/horizontalSelect/horizontalSelect.component";
import { FormlyImage } from "../../components/formlyTypes/img/img.component";
import { FormlyNoteComponent } from "../../components/formlyTypes/note/note.component";
import { PageComponent } from "../../components/formlyTypes/page/page.component";
import { PagingComponent } from "../../components/formlyTypes/paging/paging.component";
import { FormlySignaturePad } from "../../components/formlyTypes/signature-pad/signature-pad.component";
import { FormTableLightComponent } from "../../components/formlyTypes/table-light/table-light.component";
import { FormlyTable } from "../../components/formlyTypes/table/table.component";
import { FormlyTemperatureInput } from "../../components/formlyTypes/temperatureInput/temperatureInput.component";
import { FormlyTextArea } from "../../components/formlyTypes/textarea/control.component";
import { FormlyToggleButton } from "../../components/formlyTypes/toggleButton/toggleButton.component";
import { FormlyVerticalInput } from "../../components/formlyTypes/verticalInput/verticalInput.component";
import { FormlyWysiwygInput } from "../../components/formlyTypes/wysiwygInput/wysiwygInput.component";
import { FormCodeGenerator } from "../../components/generator/generator.form.component";
import { CodeGenerator } from "../../components/generator/generator.view.component";
import { ImageMarkup } from "../../components/image-markup/image-markup";
import { ImageViewerComponent } from "../../components/image-viewer/image-viewer.component";
import { MainNavComponent } from "../../components/mainnav/mainnav.component";
import { EscapeHtmlPipe } from "../../components/pipes/keep-html.pipe";
import { ProgressMeasureComponent } from "../../components/progressMeasure/progressMeasure.component";
import { SwitcherComponent } from "../../components/switcher/switcher.component";
import { TableLightColumnComponent } from "../../components/table-light/table-light-column/table-light-column.component";
import { TableLightComponent } from "../../components/table-light/table-light.component";
import { FormContacts } from "../../pages/settings/contacts/contacts.form.component";
import { FormEmployees } from "../../pages/settings/employees/employees.form.component";
import { FormLookupValues } from "../../pages/settings/lookupvalues/lookupvalues.form.component";
import { SettingsLookupValue } from "../../pages/settings/lookupvalues/lookupvalues.view.component";
import { LabelPreparationForm } from "../../pages/label-preparation/label-preparation.form.component";
import { LabelPreparationRegister } from "../../pages/label-preparation/label-preparation.register.component";
import { LabelPreparationExportComponent } from "../../pages/label-preparation/label-preparation.export.component";
import { QRCodeRegister } from "../../pages/common/qrcode/qrcode.register.component";
import { QRCodeForm } from "../../pages/common/qrcode/qrcode.form.component";
import { QRCodeModalComponent } from "../../pages/common/qrcode/qrcode-modal/qrcode-modal.component";
import { PlantQRCodeModalComponent } from "../../pages/projects/procurement/plant-qrcode/plant-qrcode-modal.component";
import { SelectButtonModule } from "primeng/selectbutton";
import { FieldsetModule } from 'primeng/fieldset'
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from "primeng/messages";
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { FormlyGrid } from "../../components/formlyTypes/grid/grid.component";
import { FormlyGridSummary } from "../../components/formlyTypes/gridSummary/grid-summary.component";
import { IndeterminateDirective } from "../../directives/indeterminate.directive";

const declarations = [
    AccordionComponent,
    AppContextMenuComponent,
    AsyncModalComponent,
    AttachmentMenu,
    BreadcrumbComponent,
    ClientSwitcherComponent,
    CodeGenerator,
    CustomMenu,
    DataList,
    DataListItem,
    DataTable,
    DataTableColumn,
    DocumentManagementSystem,
    DropDown,
    DropDownData,
    EscapeHtmlPipe,
    FooterBar,
    FormCodeGenerator,
    FormContacts,
    FormEmployees,
    FormLookupValues,
    FormlyColourPicker,
    FormlyDmsButtons,
    FormlyFileUploader,
    FormlyHorizontalCheckbox,
    FormlyHorizontalDateInput,
    FormlyHorizontalInput,
    FormlyHorizontalMultiSelect,
    FormlyHorizontalSelect,
    FormlyVerticalInput,
    FormlyImage,
    FormlyNoteComponent,
    FormlySignaturePad,
    FormlyTable,
    FormlyTemperatureInput,
    FormlyTextArea,
    FormlyToggleButton,
    FormlyWysiwygInput,
    FormlyGrid,
    FormlyGridSummary,
    FormTableLightComponent,
    ImageMarkup,
    ImageViewerComponent,
    MainNavComponent,
    PageComponent,
    PagingComponent,
    ProgressMeasureComponent,
    SettingsLookupValue,
    SwitcherComponent,
    TableLightColumnComponent,
    TableLightComponent,
    LabelPreparationForm,
    LabelPreparationRegister,
    LabelPreparationExportComponent,
    QRCodeRegister,
    QRCodeForm,
    QRCodeModalComponent,
    PlantQRCodeModalComponent,
    IndeterminateDirective
];

const imports = [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule.forRoot({
        extras: {
            resetFieldOnHide: false,
        },
        validationMessages: [
            { name: "required", message: "This field is required" },
            { name: "pattern", message: "Invalid format" },
        ],
        wrappers: [
            {
                name: "horizontalWrapper",
                component: FormlyHorizontalInput,
                types: [
                    "colour-picker",
                    "date",
                    "file-upload",
                    "hz-checkbox",
                    "hz-input",
                    "hz-select",
                    "hz-textarea",
                    "img",
                    "input",
                    "multiSelect",
                    "select",
                    "temperatureInput",
                    "toggle-button",
                    "wysiwygInput"
                ],
            },
            {
                name: "accordion",
                component: AccordionComponent,
            },
            {
                name: "verticalWrapper",
                component: FormlyVerticalInput,
                types: ["signature-pad"],
            },
            {
                name: "paging",
                component: PagingComponent,
            },
            {
                name: "page",
                component: PageComponent,
            },
            {
                name: 'grid',
                component: FormlyGrid
            }
        ],
        types: [
            { name: "colour-picker", component: FormlyColourPicker },
            {
                name: "date",
                component: FormlyHorizontalDateInput,
                extends: "input",
                defaultOptions: { type: "date" },
            },
            { name: "dms-buttons", component: FormlyDmsButtons },
            {
                name: "file-upload",
                component: FormlyFileUploader,
                defaultOptions: { defaultValue: [] },
            },
            {
                name: "hz-checkbox",
                component: FormlyHorizontalCheckbox,
                extends: "input",
                defaultOptions: { type: "checkbox" },
            },
            { name: "hz-input", extends: "input" },
            {
                name: "hz-select",
                component: FormlyHorizontalSelect,
                extends: "select",
            },
            {
                name: "hz-textarea",
                component: FormlyTextArea,
                extends: "textarea",
                defaultOptions: {},
            },
            { name: "img", component: FormlyImage },
            {
                name: "multiSelect",
                component: FormlyHorizontalMultiSelect,
                extends: "select",
            },
            { name: "note", component: FormlyNoteComponent, wrappers: [] },
            { name: "signature-pad", component: FormlySignaturePad },
            { name: "table", component: FormlyTable },
            { name: "table-light", component: FormTableLightComponent },
            { name: "temperatureInput", component: FormlyTemperatureInput },
            { name: "toggle-button", component: FormlyToggleButton },
            {
                name: "wysiwygInput",
                component: FormlyWysiwygInput,
                extends: "textarea",
            },
            {
                name: "grid",
                component: FormlyGrid,
                wrappers: ['grid']
            },
            {
                name: "grid-summary",
                component: FormlyGridSummary
            }
        ],
    }),
    AccordionModule,
    AutoCompleteModule,
    CalendarModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ColorPickerModule,
    CommonModule,
    ContextMenuModule,
    DragDropModule,
    DropdownModule,
    EditorModule,
    FileUploadModule,
    FontAwesomeModule,
    FormlyBootstrapModule,
    InputNumberModule,
    InputTextareaModule,
    MenuModule,
    MultiSelectModule,
    SelectButtonModule,
    NgIdleModule.forRoot(),
    PrimeNgColorPickerModule,
    TableModule,
    ToastModule,
    ToggleButtonModule,
    TooltipModule,
    TreeModule,
    TreeTableModule,
    TabViewModule,
    PanelModule,
    ChipModule,
    FieldsetModule,
    ProgressSpinnerModule,
    MessagesModule,
    OverlayPanelModule
];

const returnedExports = [
    AccordionComponent,
    AccordionModule,
    AppContextMenuComponent,
    AsyncModalComponent,
    AttachmentMenu,
    AutoCompleteModule,
    BreadcrumbComponent,
    CalendarModule,
    ChartModule,
    CheckboxModule,
    ChipsModule,
    ClientSwitcherComponent,
    CodeGenerator,
    ColorPickerModule,
    CommonModule,
    ContextMenuModule,
    CustomMenu,
    DataList,
    DataListItem,
    DataTable,
    DataTableColumn,
    DocumentManagementSystem,
    DragDropModule,
    DropDown,
    DropDownData,
    DropdownModule,
    EditorModule,
    EscapeHtmlPipe,
    FileUploadModule,
    FontAwesomeModule,
    FooterBar,
    FormCodeGenerator,
    FormContacts,
    FormEmployees,
    FormlyBootstrapModule,
    FormlyColourPicker,
    FormlyDmsButtons,
    FormlyFileUploader,
    FormlyHorizontalCheckbox,
    FormlyHorizontalDateInput,
    FormlyHorizontalInput,
    FormlyHorizontalMultiSelect,
    FormlyHorizontalSelect,
    FormlyVerticalInput,
    FormlyImage,
    FormlyModule,
    FormlyNoteComponent,
    FormlySignaturePad,
    FormlyTable,
    FormlyTemperatureInput,
    FormlyTextArea,
    FormlyToggleButton,
    FormlyWysiwygInput,
    FormlyGrid,
    FormlyGridSummary,
    FormsModule,
    FormTableLightComponent,
    ImageMarkup,
    ImageViewerComponent,
    InputNumberModule,
    InputTextareaModule,
    MainNavComponent,
    MenuModule,
    MultiSelectModule,
    SelectButtonModule,
    NgIdleModule,
    PageComponent,
    PagingComponent,
    PrimeNgColorPickerModule,
    ProgressMeasureComponent,
    ReactiveFormsModule,
    SettingsLookupValue,
    SwitcherComponent,
    TableLightColumnComponent,
    TableLightComponent,
    TableModule,
    ToastModule,
    ToggleButtonModule,
    TooltipModule,
    TreeModule,
    TreeTableModule,
    TabViewModule,
    QRCodeRegister,
    QRCodeForm,
    PanelModule,
    ChipModule,
    LabelPreparationForm,
    LabelPreparationRegister,
    LabelPreparationExportComponent,
    QRCodeModalComponent,
    PlantQRCodeModalComponent,
    FieldsetModule,
    ProgressSpinnerModule,
    MessagesModule,
    OverlayPanelModule,
    IndeterminateDirective
];

@NgModule({
    declarations: declarations,
    imports: imports,
    exports: returnedExports,
})
export class PIMeoSharedModule { }
